import React from "react";
import {FormItem, FormItemProps} from './FormItem'
import {IField, getRequiredError} from './FieldValidation';
import InputMask from "react-input-mask";

export interface MaskedFieldCallback { (value: string): any }

export interface MaskedFieldProps extends FormItemProps {
    id: string
    onChange: MaskedFieldCallback
    value: string
    mask: string
    required?: boolean
    requiredMessage?: string
    block?: boolean
    maskChar?: string
}

export interface MaskedFieldState {
    value: string
    errorMessage?: string
}

export class MaskedField extends React.Component<MaskedFieldProps, MaskedFieldState> implements IField {
    input: HTMLInputElement

    constructor(props?: MaskedFieldProps, context?: any) {
        super(props, context);

        this.state = {
            value: this.props.value || ''
        };
    }

    componentDidUpdate(prevProps: MaskedFieldProps, prevState: MaskedFieldState) {
        if (this.state.value == prevState.value && this.state.value != (this.props.value || '')) {
            this.setState({ value: this.props.value || '' }, () => {
                if (this.state.errorMessage) {
                    this.validate(() => { });
                }
            })
        }
        else if (this.props.value != prevProps.value) {
            if (this.state.errorMessage) {
                this.validate(() => { });
            }
        }
    }

    onInput(v: string) {
        if (this.state.value != v) {
            this.setState({ value: v });
        }
    }

    onChange(v: string) {
        this.props.onChange(v);
    }

    render() {
        if (this.props.preview) {
            return <FormItem {...this.props} errorMessage={this.props.errorMessage || this.state.errorMessage}>
                <div className="form-value">{this.state.value ? this.state.value : "--"}</div>
            </FormItem>
        }

        return <FormItem {...this.props} inputId={this.props.id} errorMessage={this.props.errorMessage || this.state.errorMessage}>
            <div>
                <InputMask className={`emdg-text-input ` +
                    `${this.props.block === false ? '' : 'emdg-text-input--block'}` +
                    `${(this.props.errorMessage || this.state.errorMessage) ? ' emdg-text-input--invalid' : ''}`
                }
                    inputRef={r => this.input = r}
                    id={this.props.id}
                    value={this.state.value}
                    onChange={e => this.onInput(e.target.value)}
                    onBlur={e => this.onChange(e.target.value)}
                    mask={this.props.mask}
                    maskChar={this.props.maskChar}
                    alwaysShowMask={true}
                    autoComplete='new-password' // Turn off autofill for BSB
                />
            </div>
        </FormItem>
    }

    getValue(): string {
        let v = this.props.value;
        if (!v) {
            v = '';
        }
        v.trim();
        return v;
    }

    hasValue(): boolean {
        let v = this.getValue();
        return (v.length > 0);
    }

    focus() {
        this.input.focus();
    }

    getErrorText(): string {
        let val = this.getValue();
        if (this.props.required === true) {
            if (val.length == 0) {
                return getRequiredError(this.props);
            }
        }
        return null;
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
        let errorText = this.getErrorText();
        this.setError(errorText, () => {
            if (this.props.errorMessage || errorText) {
                if (focus === true) {
                    this.focus();
                }
            }
            callback && callback((this.props.errorMessage || errorText) ? false : true);
        })
    }

    setError(errorMessage?: string, callback?: { (): any }) {
        this.setState({ errorMessage }, callback);
    }
}